import ReactDOM from "react-dom";
import { BrandLink } from "./brand-link";
import React from "react";

let brandLinkWrapper;

export const unmount = () => {
  if (!brandLinkWrapper) {
    return;
  }
  ReactDOM.unmountComponentAtNode(brandLinkWrapper);
};

export default () => {
  brandLinkWrapper = document.querySelector("#brand-link-app");
  if (!brandLinkWrapper) {
    return;
  }

  return ReactDOM.render(
    <BrandLink
      brandName={brandLinkWrapper.getAttribute("data-brand-name")}
      brandLink={brandLinkWrapper.getAttribute("data-brand-link")}
      subBrandName={brandLinkWrapper.getAttribute("data-sub-brand-name")}
      subBrandLink={brandLinkWrapper.getAttribute("data-sub-brand-link")}
      rootElement={brandLinkWrapper}
    />,
    brandLinkWrapper
  );
}
